export default __webpack_public_path__ + "c7ba8075b6855057e779fb688ff3dd3d.svg";